import extendedFieldHooks from "ExtendedFields/selectorHooks";
import FnrTypography from "FnrTypography/FnrTypography";

import FnrCard from "UI/FnrCard/FnrCard";
import FnrIcon from "UI/FnrIcon/FnrIcon";
import { FnrRadioButtonOption } from "UI/FnrRadioButtonOption";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

import extendedFieldInputContainers from "../containers";

const { IconContainer, VerticallyCentered } = extendedFieldInputContainers;

const Multiline = () => {
  const [multiline, setMultiline] = extendedFieldHooks.useMultiline();
  const isReadOnly = extendedFieldHooks.useIsReadOnly();

  const handleRemoveMultiline = () => setMultiline(false);
  const handleAddMultiline = () => setMultiline(true);

  return (
    <FnrCard data-cy="ExtendedFields_Multiline">
      <VerticallyCentered>
        <IconContainer $color="textSecondary">
          <FnrIcon icon="fa-align-left fas" />
        </IconContainer>
        <FnrVerticalGap>
          <FnrTypography>
            How many lines should the text box have?
          </FnrTypography>
          <FnrHorizontalGap>
            <FnrRadioButtonOption
              isActive={!multiline}
              onClick={handleRemoveMultiline}
              noMargin
              disabled={isReadOnly}
            >
              <span>Single</span>
            </FnrRadioButtonOption>
            <FnrRadioButtonOption
              isActive={multiline}
              onClick={handleAddMultiline}
              noMargin
              disabled={isReadOnly}
            >
              <span>Multiple</span>
            </FnrRadioButtonOption>
          </FnrHorizontalGap>
        </FnrVerticalGap>
      </VerticallyCentered>
    </FnrCard>
  );
};

export default Multiline;
